import { namespace, SettingsProfileState } from '../store';
import { createSelector } from 'reselect';

export const selectStore = (state: { [namespace]?: SettingsProfileState }) =>
  state[namespace];

/** Everything the fetch returned, deleted rows included. */
export const selectAllProfileRecords = createSelector(
  selectStore,
  (s) => s?.profileList ?? []
);

/**
 * The profiles a user may see and choose.
 *
 * `!== true` rather than `=== false`: profiles written before VE-28768 carry
 * no `isDeleted` at all, and those are live.
 */
export const selectProfileList = createSelector(
  selectAllProfileRecords,
  (list) => list.filter((profile) => profile.data.isDeleted !== true)
);

/** The deleted view. */
export const selectDeletedProfileList = createSelector(
  selectAllProfileRecords,
  (list) => list.filter((profile) => profile.data.isDeleted === true)
);

export const selectDefaultProfile = createSelector(selectProfileList, (list) =>
  list.find((profile) => profile.data.isDefault)
);

export const selectIsFetchProfileListInProgress = createSelector(
  selectStore,
  (s) => s?.isFetchProfileListInProgress
);
